import React from "react";
import { TspBreadcrumb } from "../../components/primitives";
import TspLoadError from "../../components/common/TspLoadError";
import TspMasterDataCard from "../../components/patterns/TspMasterDataCard";
import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";
import useTspLocationResourceData from "../../hooks/useTspLocationResourceData";
import useTspPermission from "../../hooks/useTspPermission";
import TSP_PERMISSIONS from "../../constants/tspPermissions";
import TspBackButton from "../../components/common/TspBackButton";

const EMPTY_DRAFT = { state_id: "", city_name: "", name: "", phone: "", email: "", category: "" };
const CATEGORY_OPTIONS = ["Temple Coordinator", "Bus Leader", "Local Guide", "Police/Permission", "Vendor", "Other"];

export default function TspContactsPage() {
  const { hasPermission } = useTspPermission();
  const canManage = hasPermission(TSP_PERMISSIONS.CONTACTS_MANAGE);
  const states = useTspApiResource(() => TspApiService.listStates(), []);
  const { loading, error, reload, records, add, remove } = useTspLocationResourceData(TspApiService.contacts);

  if (loading) return <div className="tsp-page tsp-dashboard-loading">Loading contacts…</div>;
  if (error) return <TspLoadError error={error} onRetry={reload} what="contacts" />;

  const columns = [
    { key: "name", label: "Name" },
    { key: "phone", label: "Phone", render: (row) => row.phone || "—" },
    { key: "category", label: "Category", render: (row) => row.category || "—" },
    { key: "location", label: "City", render: (row) => row.location?.label || "—" },
    { key: "email", label: "Email", render: (row) => row.email || "—" },
    { key: "remarks", label: "Notes", render: (row) => row.remarks || "—" },
  ];

  const fields = [
    { key: "state_id", label: "State", type: "select", options: (states.data || []).map((s) => ({ value: String(s.id), label: s.name })), required: true },
    { key: "city_name", label: "City", required: true },
    { key: "name", label: "Name", required: true },
    { key: "phone", label: "Phone" },
    { key: "category", label: "Category", type: "select", options: CATEGORY_OPTIONS },
    { key: "email", label: "Email" },
  ];

  const handleAdd = (draft) => {
    const body = { state_id: Number(draft.state_id), city_name: draft.city_name.trim(), name: draft.name.trim() };
    if (draft.phone.trim()) body.phone = draft.phone.trim();
    if (draft.category.trim()) body.category = draft.category.trim();
    if (draft.email.trim()) body.email = draft.email.trim();
    return add(body);
  };

  return (
    <div className="tsp-page">
      <div className="tsp-page-heading-row">
        <div>
          <h1>Contact Directory</h1>
          <TspBreadcrumb items={["Dashboard", "Contacts"]} />
        </div>
        <TspBackButton fallback="/tsp" />
      </div>
      <TspMasterDataCard
        title="Contacts"
        columns={columns}
        fields={fields}
        records={records}
        emptyDraft={EMPTY_DRAFT}
        canManage={canManage}
        onAdd={handleAdd}
        onDelete={remove}
        rowLabel={(row) => row.name}
      />
    </div>
  );
}
